// eslint-disable-next-line import/prefer-default-export
export const BACK_BUTTON_GATEWAY = 'back-button';



// WEBPACK FOOTER //
// ./src/app/kiosk/constants.js